import { LONG_FORM_DRAFT_STATUS } from './const';
import type { LongFormDraft } from './types';

export const isLongFormDraftGenerating = (draft?: LongFormDraft): boolean => {
  if (!draft) {
    return false;
  }

  return draft.status === LONG_FORM_DRAFT_STATUS.generating || draft.currentGenerationJobId != null;
};

export const isLongFormDraftEditing = (draft?: LongFormDraft): boolean => {
  if (!draft) {
    return false;
  }

  return draft.status === LONG_FORM_DRAFT_STATUS.editing;
};

export const isLongFormDraftVisible = (draft?: LongFormDraft): boolean => {
  return isLongFormDraftGenerating(draft) || isLongFormDraftEditing(draft);
};
